<template>
  <div class="sure_enc_box">
    <div class="sure_enc_titTip"><img src='./images/tip.png'/><span>{{encRes && encRes.tip}}</span></div>
    <ul class="sure_enc_cont">
        <li class="sure_enc_cont_list">
            <span class="cont_list_tit">订单类型：</span>
            <span class="cont_list_cont">电子公证</span>
        </li>
        <li class="sure_enc_cont_list" v-if='encRes && Number(encRes.packageNum) > 0'>
            <span class="cont_list_tit">消耗次数：</span>
            <span class="cont_list_cont">{{encRes && encRes.packageNum}}次</span>
        </li>
        <li class="sure_enc_cont_list">
            <span class="cont_list_tit">取证文件大小：</span>
            <span class="cont_list_cont">{{encRes && encRes.fileSizeDesc}}</span>
        </li>
        <li class="sure_enc_cont_list" v-if='encRes && Number(encRes.price) >0'>
            <span class="cont_list_tit">订单金额：</span>
            <span class="cont_list_cont">{{encRes && encRes.priceDesc}}</span>
        </li>
        <li class="sure_enc_cont_list">
            <span class="cont_list_tit">余额：</span>
            <span class="cont_list_cont">{{encRes && encRes.amountDesc?encRes.amountDesc: '0元'}}</span>
            <a style="cursor: pointer;margin-left:20px" @click='goCz' v-if='encRes && (Number(encRes.amount?encRes.amount:0)<Number(encRes.price))'>去充值</a>
        </li>
    </ul>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
import {userInfo} from "@/api/index";

export default {
  name: "payWayEnc",
  props: ["type","batchNum", "width","isRenew",'encType','orderNo'],
  data() {
    return {
      userInfo:"",
      encRes:null,
      dzRes:null
    };
  },
  components:{
  },
  methods: {
      initPayWay(){
          try {
            this.userInfo = JSON.parse(Cookies.get("userInfo"))
            return this.getRequest("/notarial/enc/getDeductTip/"+this.encType+"/" + this.orderNo).then(data => {
                if (data.success) {
                    this.encRes = data.result;
                    this.$emit('resFn',data.result)
                }
            });
        } catch (error) {
            console.error(error)
        }
      },
      goCz(){
          this.$router.push({
              path:'/walletPackage'
          })
      }
  },
  created() {
    this.initPayWay()
  }
};
</script>

<style lang="less">
.sure_enc_box{
    padding: 0 36px 0 28px;
    box-sizing: border-box;
    text-align: left;
    .sure_enc_titTip{
        display: flex;
        font-size: 12px;
        color: #BDBDBD;
        line-height: 18px;
        vertical-align: middle;
        img{
            width: 12px;
            height: 12px;
            display: inline-block;
            margin-right:5px;
            vertical-align: middle;
        }
        span{
            flex: 1;
        }
    }
    ul{
        margin-top: 24px;
        margin-bottom: 20px;
        padding-left:18px;
        li{
            list-style: none;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
        }
        .sure_enc_cont_list{
            margin-top: 10px;
            .cont_list_cont{
                color: #333333;
            }
        }
    }

}
</style>
